import { C } from "@/brand/tokens";

/**
 * F1CMonogram — the secondary mark (favicon / collateral), NOT the header logo.
 *
 * "F1" dominant; a small "C" sits at the upper-right corner of the "1",
 * subordinate in scale and weight. Proportions must stay consistent in
 * every context (intended for trademark).
 *
 * Props: size (px), tone: ink | light | primary | onDark | filled, showRule
 */
export function F1CMonogram({ size = 56, tone = "ink", showRule = true }) {
  const palettes = {
    ink: { bg: "transparent", border: C.textOnLight, text: C.textOnLight, rule: C.accentMetal },
    light: { bg: "transparent", border: C.whiteOnDark, text: C.whiteOnDark, rule: C.accentMetal },
    primary: { bg: "transparent", border: C.surfacePrimary, text: C.surfacePrimary, rule: C.accentMetal },
    onDark: { bg: "transparent", border: C.accentMetal, text: C.textOnDark, rule: C.accentMetal },
    filled: { bg: C.surfacePrimary, border: C.surfacePrimary, text: C.textOnDark, rule: C.accentMetal },
  };
  const p = palettes[tone] || palettes.ink;
  const fontSize = size * 0.5;
  const strokeWidth = Math.max(1, size / 56);

  return (
    <div
      data-testid="f1c-monogram"
      className="inline-flex items-center justify-center relative"
      style={{
        width: size,
        height: size,
        background: p.bg,
        border: `${strokeWidth}px solid ${p.border}`,
        color: p.text,
      }}
      aria-label="Faith 1st Consulting monogram"
    >
      <span
        className="font-cormorant leading-none relative"
        style={{ fontSize: `${fontSize}px`, letterSpacing: "-0.02em", fontWeight: 500, marginLeft: `-${size * 0.08}px`, marginTop: `-${size * 0.06}px` }}
      >
        F1
        <span
          aria-hidden="true"
          className="absolute font-cormorant leading-none"
          style={{ top: "-0.08em", right: "-0.5em", fontSize: "0.36em", fontWeight: 500 }}
        >
          C
        </span>
      </span>
      {showRule && (
        <span
          aria-hidden="true"
          className="absolute"
          style={{
            bottom: size * 0.16,
            left: "50%",
            transform: "translateX(-50%)",
            width: size * 0.3,
            height: 1,
            background: p.rule,
          }}
        />
      )}
    </div>
  );
}
